import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import { getDefaultModalData, getDefaultModalUI } from "components/custom-ui/CustomModal/components/FirstTimeLoginModal";
import LoginPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/LoginPage";

/**
 * @name CaptureFirstLoginCodeEntered
 * @returns {React.Component}
 * @description Capture component for the login page showing the user and password
 * fields filled. And the second step of the first time login modal showing
 */
export default function CaptureFirstLoginCodeEntered(props) {
    const modalUI = getDefaultModalUI();
    const modalData = getDefaultModalData();

    // Initalize a new BCMSStateManagerCRUD with the default modal data and ui
    // required updating the step and confirmationCode properties
    const modal = BCMSStateManagerCRUD.init({ data: modalData, ui: modalUI })
        .update([ "ui", "step" ], 1)
        .update([ "data", "confirmationCode" ], "760382")
        .submit();
    // Initalize a new BCMSStateManagerCRUD using the default page data
    // setting the user id and password properties
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "userID" ], "DemoUser")
        .update([ "password" ], "123456789")
        .submit();
    // initalize a new BCMSStateManagerCRUD instance using the default page ui
    // updating the modal property
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "modal", "id" ], "FirstTimeLoginModal")
        .update([ "modal", "data" ], modal)
        .submit();

    return <LoginPage data={ data } ui={ ui } />
}